import React, { useState } from 'react';

import { EAllowStatus } from '~/src/dash/api/console-api';
import { ITargetingPreset, TargetingPresetKey } from '~/src/dash/apiV2/targeting/targetingPresets';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { fontSizing, spacing, Text, TextButton } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { TargetingPresetParamKey } from '~/src/dash/views/tools/TargetingPresets/TargetingPresetFormView/config';

const formatCommaSeparatedString = (value: string) => {
  if (!value) return '';
  return value.split(',').join(', ');
};

const isValueAllowed = (
  preset: ITargetingPreset,
  allowKey: TargetingPresetKey,
  isAllowTypeBool?: boolean,
): boolean => {
  if (isAllowTypeBool) {
    return preset[allowKey] !== false;
  } else {
    return preset[allowKey] !== EAllowStatus.DENY;
  }
};

export interface IIncludeExcludeStringProps {
  preset: ITargetingPreset;
  valueKey: TargetingPresetKey;
  allowKey: TargetingPresetKey;
  isAllowTypeBool?: boolean;
  paramKey: TargetingPresetParamKey;
}

export const IncludeExcludeString = ({
  preset,
  valueKey,
  allowKey,
  isAllowTypeBool = false,
}: IIncludeExcludeStringProps) => {
  const value = formatCommaSeparatedString(preset[valueKey] as string);
  const isExpandNeeded = value.length > 160;
  const truncatedValue = value.substring(0, 157) + '...';
  const [isExpanded, setIsExpanded] = useState(!isExpandNeeded);
  return (
    <div>
      <Text small>
        {value && allowKey && (
          <span
            style={{
              verticalAlign: 'middle',
              lineHeight: fontSizing.small,
              paddingRight: spacing.extraSmall,
            }}
          >
            {isValueAllowed(preset, allowKey, isAllowTypeBool) ? (
              <IconV2 name='available' color={publicaColors.green} />
            ) : (
              <IconV2 name='unavailable' color={publicaColors.red} />
            )}
          </span>
        )}
        {isExpanded ? value : truncatedValue}
      </Text>
      {isExpandNeeded && (
        <TextButton size='extraSmall' onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? 'Collapse' : 'Expand'}
        </TextButton>
      )}
    </div>
  );
};
